import type { InsertDepartmentTypeGroupByNameMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcResponseToGraphQL = (
  id: string
): InsertDepartmentTypeGroupByNameMutation => {
  return {
    insert_department_type_group_one: {
      __typename: 'department_type_group',
      Id: id,
    },
  };
};

export const useInsertDepartmentTypeGroupByNameTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.department.insertTypeGroupByName.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.department.departmentTypeGroups.queryKey(),
        });
      },
    }),
  });

  return {
    insertDepartmentTypeGroupByName: async (variables: {
      Name: string;
    }): Promise<InsertDepartmentTypeGroupByNameMutation> => {
      const result = await mutation.mutateAsync({ Name: variables.Name });

      return mapTrpcResponseToGraphQL(result.Id);
    },
    loading: mutation.isPending,
    error: mutation.error,
    data: mutation.data
      ? mapTrpcResponseToGraphQL(mutation.data.Id)
      : undefined,
  };
};
